module.exports = __webpack_public_path__ + "static/media/contact-us.2a7f99f1.png";